import { IconSvg, IconSvgProps } from "./icon"

export default function Magic(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path
        d="m9.6 14.575 1.252-2.723 2.723-1.252-2.723-1.252L9.6 6.625 8.348 9.348 5.625 10.6l2.723 1.252L9.6 14.575Zm0 3.625-2.375-5.225L2 10.6l5.225-2.375L9.6 3l2.375 5.225L17.2 10.6l-5.225 2.375L9.6 18.2Zm8.6 2.8-1.175-2.625L14.4 17.2l2.625-1.2 1.175-2.6 1.2 2.6 2.6 1.2-2.6 1.175L18.2 21Z"
        fill="currentColor"
        stroke="none"
      />
    </IconSvg>
  )
}
